export const DEFAULTS = {
  user: {
    max: 0,
    min: 0,
    pending: 0,
    owned: 0,
    parValue: 0,
    flag: true
  },
  bank: {
    bankId: 0,
    sheba: '',
    cardId: ''
  }
};

export const TABS = {
  1: 'NonMember',
  2: 'NonMemberInvestor',
  3: 'Member'
};
export const FETCH_WORDPRESS_URLS = [
  'https://parswater.com/wp-json/wp/v2/pages/1355',
  'https://parswater.com/wp-json/wp/v2/pages/1364',
  'https://parswater.com/wp-json/wp/v2/pages/1362'
];

export const FETCH_WORDPRESS_DEFAULTS = [];
